import { Suspense, lazy } from "react";
import type { ComponentProps } from "react";
import type MapViewType from "./MapView";

/**
 * mapbox-gl is ~600 KB gzipped — roughly the whole bundle. Loading it eagerly
 * means a phone on cellular stares at nothing until it arrives, even though
 * the site list, the chart and the station detail are a few kilobytes and
 * ready immediately.
 *
 * Splitting it behind Suspense lets everything else paint at once and streams
 * the map in behind a placeholder. The map is the default pane, so the
 * placeholder is sized and styled rather than blank.
 */
const MapView = lazy(() => import("./MapView"));

export type { Basemap, MapPoint } from "./MapView";

export default function LazyMap(props: ComponentProps<typeof MapViewType>) {
  return (
    <Suspense
      fallback={
        <div className="map map-loading" role="status" aria-live="polite">
          <span>Loading map…</span>
        </div>
      }
    >
      <MapView {...props} />
    </Suspense>
  );
}
